import React from "react";
import type { Dispatch, SetStateAction } from "react";

import type { AdvFilterProps } from "@utils";

export type DashboardAdvancedFilterProps = {
  label: string;
  cubeKey?: string;
  id?: string;
  parentId?: string;
  isParent?: boolean;
};

export type FilterOptionsProps = Record<
  string,
  {
    label: string;
    name: string;
    options: string[];
  }[]
>;

export type PortalContextProps = {
  filters: AdvFilterProps;
  setFilters: Dispatch<SetStateAction<object>>;
  filterOptions: object;
  setFilterOptions: Dispatch<SetStateAction<FilterOptionsProps>>;
  filterOrder?: DashboardAdvancedFilterProps[];
};

export const PortalContext = React.createContext<PortalContextProps>({
  filters: {},
  setFilters: () => {},
  filterOptions: {},
  setFilterOptions: () => {},
  filterOrder: undefined,
});
